import {
    Flex,
} from '@chakra-ui/react';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'shared/ui/Link';
import React from 'react';
import { CateringFormatModel } from 'entities/catering-format';
import { CateringEventCategoryModel } from 'entities/catering-event-category';
import { CateringEventFormatModel } from 'entities/catering-event-format';
import { SweetShopArticleCategoryModel } from 'entities/sweet-shop-article-category';
import { DeliveryArticleCategoryModel } from 'entities/delivery-article-category';
import { DeliveryArticleTagModel } from 'entities/delivery-article-tag';
import { CulinaryStudioArticleCategoryModel } from 'entities/culinary-studio-article-category';
import { OutdoorBarArticleCategoryModel } from 'entities/outdoor-bar-article-category';
import styles from './styles.module.scss';

type NavigationSectionProps = {
    cateringFormats: CateringFormatModel[]
    cateringEventCategories: CateringEventCategoryModel[]
    cateringEventFormats: CateringEventFormatModel[]
    sweetShopArticleCategories: SweetShopArticleCategoryModel[]
    deliveryArticleCategories: DeliveryArticleCategoryModel[]
    deliveryArticleTags: DeliveryArticleTagModel[]
    culinaryStudioArticleCategories: CulinaryStudioArticleCategoryModel[]
    outdoorBarArticleCategories: OutdoorBarArticleCategoryModel[]
}

export const NavigationSection: React.FC<NavigationSectionProps> = ({
    cateringEventCategories,
    cateringEventFormats,
    cateringFormats,
    culinaryStudioArticleCategories,
    deliveryArticleCategories,
    deliveryArticleTags,
    outdoorBarArticleCategories,
    sweetShopArticleCategories,
}) => (
    <Flex
        className={styles.navigationSection}
        maxWidth={{
            base: '425px',
            lg: '1280px',
        }}
        width="100%"
        margin="0 auto"
        background="white"
    >
        <div className={styles.navigationSection__main}>
            <div className={styles.navigationSection__cateringSection}>
                <h2>
                    <Link to="/catering">
                        Кейтеринг
                    </Link>
                </h2>
                <div>
                    <div>
                        <Link to="/catering?tab=formats" reloadDocument>
                            Форматы
                        </Link>
                        <ul>
                            {cateringFormats.map(({ name, slug }) => (
                                <li>
                                    <Link to={`/catering/formats/${slug}`}>
                                        {name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {cateringEventCategories.map(({ name, slug }) => (
                        <div key={slug}>
                            <div>
                                <Link to={`/catering?tab=${slug}`} reloadDocument>
                                    {name}
                                </Link>
                                <ul>
                                    {cateringEventFormats.filter(
                                        (cateringEventFormat) => (
                                            cateringEventFormat.category?.name === name
                                        ),
                                    ).map((cateringEventFormat) => (
                                        <li>
                                            <Link to={`/catering/event-format/${cateringEventFormat.slug}`}>
                                                {cateringEventFormat.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className={styles.navigationSection__sweetShopSection}>
                <h2>
                    <Link to="/sweet-shop">
                        Кондитерская Corso
                    </Link>
                </h2>
                <div>
                    {sweetShopArticleCategories.map(({ name, uid }) => (
                        <Link to={`/sweet-shop/categories/${uid}`}>
                            {name}
                        </Link>
                    ))}
                </div>
            </div>
            <div className={styles.navigationSection__deliverySection}>
                <h2>
                    <Link to="/delivery" className={styles.navigationSection__title}>
                        Доставка
                    </Link>
                </h2>
                <div>
                    <ul>
                        {deliveryArticleCategories.map(({ name, uid }) => (
                            <li>
                                <Link to={`/delivery?filter=category_${uid}`} reloadDocument>
                                    {name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                    <div>
                        <span>
                            Поводы
                        </span>
                        <div>
                            {deliveryArticleTags.map(({ uid, name }) => (
                                <Link to={`/delivery?filter=tag_${uid}`} reloadDocument>
                                    {name}
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.navigationSection__culinaryStudioSection}>
                <h2>
                    <Link to="/culinary-studio">
                        Кулинарная студия
                    </Link>
                </h2>
                <div>
                    <div>
                        {culinaryStudioArticleCategories.map(({ uid, name }) => (
                            <Link to={`/culinary-studio?tab=${uid}`} reloadDocument>
                                {name}
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
            <div className={styles.navigationSection__outdoorBarsSection}>
                <h2>
                    <Link to="/outdoor-bars">
                        Выездные бары
                    </Link>
                </h2>
                <div>
                    {outdoorBarArticleCategories.map(({ name, uid }) => (
                        <Link to={`/outdoor-bars?tab=${uid}`} reloadDocument>
                            {name}
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    </Flex>
);
